function isAuthenticationAboutToExpire(user: UserState): boolean {
	if (user && user.authorization) {
		const tenMinsBeforeAuthExpiration = +user.authorization.expiresTimestamp - 600000;
		return Date.now() >= tenMinsBeforeAuthExpiration;
	} else {
		return false;
	}
}

export function renewAuthenticationIfAboutToExpire(
		user: UserState,
		renewAuth: (authorizationToken: string) => Promise<AuthenticateResponse>): Promise<AuthenticateResponse> | void {
	if (isAuthenticationAboutToExpire(user)) {
		return renewAuth(user.authorization.authorizationToken);
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/auth.ts